import { bootstrapQueryOptions, sessionQueryOptions } from "~/app/api/pageData";
import { queryClient } from "~/app/queryClient";
import { startZoovuTracking } from "./zoovuTracking";

/**
 * Starts Zoovu tracking when enabled, deriving the gate at runtime from Session Data
 * instead of the retired global Zoovu-enable wire field (F23).
 *
 * Tracking is enabled only when Zoovu is enabled for the site and a project id is
 * configured — the same rule the legacy `reactVariables.tag` emission applied
 * (Zoovu enabled and a non-empty project id). The effective enablement is Session-owned;
 * the project id remains static Bootstrap configuration.
 */
export async function initZoovuTracking(): Promise<void> {
  try {
    const [{ commerceContext }, { configuration }] = await Promise.all([
      queryClient.fetchQuery(sessionQueryOptions()),
      queryClient.fetchQuery(bootstrapQueryOptions()),
    ]);
    if (commerceContext.zoovuEnabled && configuration.zoovuProjectId) {
      startZoovuTracking(configuration.zoovuProjectId);
    }
  } catch {
    // Bootstrap Data unavailable — tracking stays off (best-effort analytics).
  }
}
